import { CollectionReference, DocumentData, collection } from "firebase/firestore";
import serializable, { propretyCustomSerializable } from "../common/decorators/serializable";
import { EntityFirebase } from "../common/entity.firebase";
import firebase from "../core/firebase";
import application from "../core/application";
import { ProductCategory } from "./product-category.entity";
import { ProductCategoriesRepository, productCategoriesRepository } from "./product-categories.repository";
import { ProductSupplier } from "./product-supplier.entity";
import { productSupplierRepository } from "./product-supplier.repository";

export const noImage = 'data:image/png;base64,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';

export type ProductSupplierCostEntry = {
    supplier: ProductSupplier;
    purchasePrice: number;
};

@serializable
export class Product extends EntityFirebase {

    @propretyCustomSerializable(category => category?.id || null)
    private category: ProductCategory|null = null;

    @propretyCustomSerializable(supplier => supplier?.id || null)
    private supplier: ProductSupplier|null = null;

    @propretyCustomSerializable((costs: ProductSupplierCostEntry[]) =>
        costs.map(c => ({ supplierId: c.supplier.id, purchasePrice: c.purchasePrice }))
    )
    private supplierCosts: ProductSupplierCostEntry[] = [];

    constructor(
        public readonly id: string,
        private name: string,
        private price: number,
        private image: string,
        category: ProductCategory|null = null,
        supplier: ProductSupplier|null = null,
        private stock: number = 1,
        /** Se false, o estoque não é usado na venda nem nos relatórios de falta. */
        private trackStock: boolean = true,
        /** SKU / código de barras — opcional; o id do documento é independente. */
        private code: string | null = null,
        /** Texto auxiliar para busca (nome já é indexado por prefixo). */
        private description: string = "",
        supplierCosts: ProductSupplierCostEntry[] = [],
    ) {
        super();
        this.category = category;
        this.supplier = supplier;
        this.supplierCosts = supplierCosts;
    }

    getName() {
        return this.name;
    }

    setName(name: string) {
        this.name = name;
    }

    getImage() {
        return this.image;
    }

    setImage(image: string) {
        return this.image = image;
    }

    getPrice() {
        return this.price;
    }

    setPrice(price: number) {
        return this.price = price;
    }

    getCollection(): CollectionReference<DocumentData> {
        return application.getCollection("products");
    }

    getCategory(): ProductCategory|null {
        return this.category;
    }

    setCategory(category: ProductCategory|null) {
        this.category = category;
    }

    getSupplierCosts(): ProductSupplierCostEntry[] {
        return this.supplierCosts;
    }

    setSupplierCosts(costs: ProductSupplierCostEntry[]) {
        this.supplierCosts = costs;
        this.supplier = costs[0]?.supplier ?? null;
    }

    getSulier(): ProductSupplier|null {
        return this.supplierCosts[0]?.supplier ?? this.supplier;
    }

    setSupplier(supplier: ProductSupplier|null) {
        this.supplier = supplier;
    }
    
    getStock() {
        return this.stock;
    }

    /** Se false, vendas não baixam estoque e o item não entra no relatório de faltas. */
    getTrackStock(): boolean {
        return this.trackStock;
    }

    setTrackStock(value: boolean) {
        this.trackStock = value;
    }

    decrementStock(quantity: number) {
        if (!this.trackStock) return;
        let newStock = this.stock - quantity;
        if (newStock < 0) newStock = 0;

        this.stock = newStock;
    }

    setStock(stock: number) {
        return this.stock = stock;
    }

    getCode(): string | null {
        return this.code;
    }

    setCode(value: string | null) {
        const v = value?.trim() ?? "";
        this.code = v.length > 0 ? v : null;
    }

    getDescription(): string {
        return this.description;
    }

    setDescription(value: string) {
        this.description = value ?? "";
    }

    /** Documentos novos usam UUID; não confundir com código de barras na UI. */
    private static isDocumentIdUuid(id: string): boolean {
        return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
            id
        );
    }

    /**
     * Rótulo único para listagens: prioriza o campo `code`; em legado (id não-UUID era o código de barras),
     * mostra esse id como código; se for UUID sem `code`, "Sem código" — nunca exibir UUID como dado interno mascarado de código.
     */
    getCodeLabelForUi(): string {
        const c = this.getCode()?.trim();
        if (c) {
            return `Cód. ${c}`;
        }
        if (!Product.isDocumentIdUuid(this.id)) {
            return `Cód. ${this.id}`;
        }
        return "Sem código";
    }

    static async build(id: string, data: any) {
        if (data.category) {
            try {
                data.category = await productCategoriesRepository.findById(data.category);
            } catch(err) {
                data.category = null;
                console.error('Erro para consultar categoria do produto, removendo cateogria...', err);
            }
        }

        let resolvedSupplierCosts: ProductSupplierCostEntry[] = [];

        if (Array.isArray(data.supplierCosts) && data.supplierCosts.length > 0) {
            const results = await Promise.all(
                data.supplierCosts.map(async (c: any) => {
                    try {
                        const sup = await productSupplierRepository.findById(c.supplierId);
                        return { supplier: sup, purchasePrice: parseFloat(c.purchasePrice) || 0 };
                    } catch {
                        return null;
                    }
                })
            );
            resolvedSupplierCosts = results.filter(Boolean) as ProductSupplierCostEntry[];
            data.supplier = resolvedSupplierCosts[0]?.supplier ?? null;
        } else if (data.supplier) {
            try {
                data.supplier = await productSupplierRepository.findById(data.supplier);
                resolvedSupplierCosts = [{ supplier: data.supplier, purchasePrice: 0 }];
            } catch(err) {
                data.supplier = null;
                console.error('Erro para consultar fornecedor do produto, removendo fornecedor...', err);
            }
        }

        const stock =
            typeof data.stock === "number" && !Number.isNaN(data.stock) ?
                data.stock :
                1;
        const trackStock = data.trackStock !== false;

        const codeRaw = data.code;
        const code =
            typeof codeRaw === "string" && codeRaw.trim() !== "" ? codeRaw.trim() : null;
        const description =
            typeof data.description === "string" ? data.description : "";

        return new this(
            id,
            data.name,
            parseFloat(data.price),
            data.image,
            data.category,
            data.supplier,
            stock,
            trackStock,
            code,
            description,
            resolvedSupplierCosts,
        );
    }
}